export default "__VITE_ASSET__X71vB49s__"